module.exports = __webpack_public_path__ + "img/image_2.3d2f28b3.png";